import { cloneElement, isValidElement } from "react";

export default function Grid({ children, as, className, ...props }) {
  const computedClassName = ["grid", ...className.split(" ")].join(" ").trim();
  return (
    (!!as &&
      isValidElement(as) &&
      cloneElement(
        as,
        { className: computedClassName, ...props },
        children,
      )) || (
      <div className={computedClassName} {...props}>
        {children}
      </div>
    )
  );
}

Grid.defaultProps = {
  className: "",
};
